export default "__VITE_ASSET__055404a9__"